module.exports = __webpack_public_path__ + "img/icon-binge-warning.3424b667.svg";